const awsConfiguration = {
  region: "ap-northeast-1",
  UserPoolId: "ap-northeast-1_hbmngMG0P",
  ClientId: "sm0l8p8aknb18tb4tkg68dqeq"
}
export default awsConfiguration
